import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import { request } from "../../../utils/Request";
import UrlHelper from "js-url-helper";
import qs from "qs";
import { Route, Routes } from "react-router-dom";
import { Toast } from "primereact/toast";
import PriceList from "./partials/PricetList";
import { getFromStorage, setToStorage } from "../../../utils/Helper";

const DEFAULT_DROPDOWNS = {
    brands: [],
    models: [],
    priceTypes: [],
    routes: [],
    transportModes: [],
};

const url = new UrlHelper();

const Price = (props: any) => {
    const { t } = props;
    const toast = useRef(null);
    const [dropdowns, setDropdowns] = useState<any>(null);
    const [moduleState, setModuleState] = useState<any>({
        page: 1,
        per_page: 20,
        search: null,
        initialized: false,
        sort_field: null,
        sort_order: null,
    });

    const getDropdowns = async () => {
        try {
            const response = await request({
                url: '/suppliers/prices/create',
                params: {
                    type: 'list',
                }
            });
            const { data } = response.data;

            setDropdowns({
                brands: data.brands,
                models: data.models,
                priceTypes: data.priceTypes,
                routes: data.routes,
                transportModes: data.transportModes,
            });
        } catch (e) {
            setDropdowns(DEFAULT_DROPDOWNS);
        }  finally {
            const prevUrl = qs.parse(url.getSearchParam().prev_url ?? "");
            const fromStorage: any = getFromStorage('supplierPriceModuleState');
            const defaultState = {
                page: !isEmpty(prevUrl.page) ? url.getSearchParam().page : 1,
                per_page: !isEmpty(prevUrl.per_page) ? url.getSearchParam().per_page : 20,
                search: !isEmpty(prevUrl.search) ? url.getSearchParam().search : null,
                initialized: true,
                sort_field: null,
                sort_order: null,
                ...(!isEmpty(fromStorage) ? JSON.parse(fromStorage) : {})
                // filters: !isEmpty(prevUrl.filters) ? url.getSearchParam().filters : qs.stringify({
                //     statuses: ['produced']
                // }),
            }

            setModuleState(defaultState);
            setToStorage('supplierPriceModuleState', JSON.stringify(defaultState));
        }
    };

    useEffect(() => {
        document.title = t("prices");

        async function init() {
            await getDropdowns();
        }

        init();
    }, []);

    const toastify = (message: any, color: string = 'info', summary: any = null) => {
        if ( toast && toast.current ) {
            // @ts-ignore
            toast.current.show({ severity: color, summary: summary, detail: message });
        }
    };

    const setQuery = (value: any) => {
        setToStorage('supplierPriceModuleState', JSON.stringify(value));
        setModuleState(value);
    }

    return (
        <div className={ "module-container" }>
            <Toast ref={ toast } />
            <div className="layout-content">
                { ( moduleState && moduleState.initialized ) ?
                    <React.Fragment>
                        <Routes>
                            <Route path={ "/" } element={
                                <PriceList
                                    moduleState={ moduleState }
                                    dropdowns={ dropdowns }
                                    toastify={ toastify }
                                    setQuery={ setQuery }
                                /> } />
                        </Routes>
                    </React.Fragment>
                    : <h6>{ t('loading') }</h6> }
            </div>
        </div>
    );
};

// Price.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(Price);
